import React from 'react';

export const IconNoticeNoti = ({
  width = 24,
  height = 24,
  color = '#4864FF',
  ...props
}: JSX.IntrinsicElements['svg']) => (
  <svg width={width} height={height} viewBox='0 0 24 24' fill='none' {...props}>
    <path
      d='M11 5H2V17H5.1C5.1 17.1 5.1 17.2 5.1 17.2C5.1 19.6 7.1 21.6 9.5 21.6C11.7 21.6 13.5 20 13.8 17.8L21 20V2L11 5ZM4 15V7H5.7V15H4ZM11.9 17.3C11.9 18.6 10.8 19.7 9.5 19.7C8.2 19.7 7.1 18.6 7.1 17.3C7.1 17.2 7.1 17.1 7.1 17.1H11L11.9 17.3ZM19 17.3L11.6 15.1L11.3 15H11H7.7V7H11H11.3L11.6 6.9L19 4.7V17.3Z'
      fill={color}
    />
  </svg>
);
